import instance from "../../../axios";

export const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

/** CMS dashboard query defaults used across Maintenance / Sales dashboards */
export const cmsParams = (ctx = {}) => ({
  contractType: Number(ctx?.ServerSetting?.contractType) || 1,
  userType: 3,
});

export const unwrapList = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.items)) return res.items;
  return [];
};

export const monthRange = (offset = 0) => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  const end = new Date(
    now.getFullYear(),
    now.getMonth() + offset + 1,
    0,
    23,
    59,
    59,
    999
  );
  return {
    from: start.toISOString(),
    to: end.toISOString(),
    label: start.toLocaleDateString(undefined, {
      month: "long",
      year: "numeric",
    }),
  };
};

export const get = (url, params) =>
  instance({
    url,
    method: "GET",
    headers,
    params,
  });

export async function fetchPaged(buildUrl, { maxPages = 6, limit = 50 } = {}) {
  const items = [];
  for (let page = 1; page <= maxPages; page += 1) {
    const res = await get(buildUrl(page, limit));
    const chunk = unwrapList(res);
    items.push(...chunk);
    if (!res?.hasNext || !chunk.length) break;
  }
  return items;
}

export { instance };
